export default {getBrand};

function getBrand() {
    const map = JSON.parse(process.env.VUE_APP_BRAND_ID_MAP);
    const hostname = window.location.hostname;
    const brandId = map[hostname];
    if (!brandId) {
        return "cybersmart";
    } else {
        return brandId;
    }
}